// src/SectionHeader.jsx
import React from 'react';
import { Box, Stack, Typography, Link } from '@mui/material';

function slugify(s) {
  return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}

export default function SectionHeader({ metaTitle, title, intro, updatedAt }) {
  const id = slugify(title);
  return (
    <Box sx={{ pt: metaTitle ? 4 : 3, pb: intro ? 1.5 : 1 }}>
      {/* Meta header — largest after page title */}
      {metaTitle && (
        <Typography variant="h5" sx={{ color: 'text.secondary', fontWeight: 700, mb: 1 }}>
          {metaTitle}
        </Typography>
      )}

      {/* Section header */}
      <Stack direction="row" alignItems="baseline" spacing={1} sx={{ mb: 0.5 }}>
        <Typography id={id} variant="h6" sx={{ fontWeight: 700 }}>{title}</Typography>
        <Link href={`#${id}`} underline="hover" color="text.secondary" sx={{ opacity: 0, transition: 'opacity .15s' }}>#</Link>
        {updatedAt && <Typography variant="caption" sx={{ color: 'text.secondary' }}>— {updatedAt}</Typography>}
      </Stack>

      {/* Sub-header (intro): slightly smaller than header, italicized, with extra padding below */}
      {intro && (
        <Typography variant="body1" sx={{ color: 'text.secondary', fontStyle: 'italic', mb: 2 }}>
          {intro}
        </Typography>
      )}

      <style>{`
        #${id}:hover + a { opacity: 1; }
      `}</style>
    </Box>
  );
}
